import { Box, Divider, Grid, Stack } from "@mui/material";
import Header from "../atoms/Header";
import { useNavigate } from "react-router-dom";
import Item from "../atoms/Item";
import ThemedButton from "../atoms/ThemedButton";
import PinInput from "react-pin-input";
import React, { useEffect, useState } from "react";
import NumPad from "../organisms/NumPad";
import { useMutation, useReactiveVar } from "@apollo/client";
import { cartItemsVar, clientInfoVar, totalVar } from "../../graphql/reactiveVars";
import OtpTimer from "otp-timer";
import { GENERATE_OTP, VERIFY_OTP } from "../../graphql/otp_endpoint/mutations";
import { ENVIRONMENT } from "../../config";
import ModalBox from "../atoms/ModalBox";
import { ErrorIcon } from "../../assets/icon";
import { useAnalytics } from "../../analytics";
import { CURRENT_SCREEN_NAME } from "../../analytics/useAnalytics";
import { sendOrders } from "../../graphql/actions/cartActions";
import { clearData } from "../../graphql/actions/uiActions";

const VerifyUserPage = ({ distributor }) => {
  const [generateOTP] = useMutation(GENERATE_OTP, {
    context: {
      endpoint: "OTP_ENDPOINT",
    },
    onError: (err) => {
      console.log(err.cause);
    },
  });

  const [verifyOTP] = useMutation(VERIFY_OTP, {
    context: {
      endpoint: "OTP_ENDPOINT",
    },
    onError: (err) => {
      // console.log(err.cause);
      // console.log(err.clientErrors);
      // console.log(err.extraInfo);
      // console.log(err.graphQLErrors);
      // console.log(err.message);
      // console.log(err.name);
      // console.log(err.networkError);
      // console.log(err.protocolErrors);
      // console.log(err.stack);
    },
    onCompleted: (data) => {
      console.log(data);
    },
  });

  const clientInfo = useReactiveVar(clientInfoVar);
  const cartItems = useReactiveVar(cartItemsVar);
  const totalCost = useReactiveVar(totalVar);

  const mobileNumber = clientInfo.mobile_number
    .split("") // turn the string into an array
    .map((n, index) => {
      if (index <= 3) return n; // return the first 4 numbers
      if (index > 3 && index <= 7) return "*"; // return the 4th to 8th number as asterisk

      return n; // return the last 3 numbers
    })
    .join(""); // turn the array into a string;

  const navigate = useNavigate();
  const [otpVal, setOtpVal] = useState("");
  const [otpAttempts, setOtpAttempts] = useState(null);
  const [isOtpExpired, setIsOtpExpired] = useState(false);
  const [isMaxAttemptsReached, setIsMaxAttemptsReached] = useState(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);

  const pinRef = React.createRef();
  const [autoSelect, setAutoSelect] = useState(true);

  const clearPin = () => {
    const pin = pinRef.current;

    pin.currentIndex = 0;

    pin.clear();

    setOtpVal("");
  };

  const { fireViewScreenEvent, firePlaceOrderEvent } = useAnalytics();

  const onChangePinHandler = (inputValue, inputIndex) => {
    const pin = pinRef.current;
    const stringVal = inputValue.toString();

    setOtpVal(stringVal);

    pin.currentIndex = inputIndex; // update the current index of the pinRef
  };

  const onVerifyUser = async () => {
    try {
      const { data, errors } = await verifyOTP({
        variables: {
          otp: otpVal,
          mobile_number: clientInfo.mobile_number,
          request_type: ENVIRONMENT === "DEV" ? "SUKICLUB" : "SARIPAY",
        },
      });

      if (errors) {
        if (errors.message) {
          if (errors.message.toUpperCase() === "INCORRECT OTP") {
            if (errors?.cause?.data?.remaining_verification_attempts) {
              setIsOtpExpired(false);
              setOtpAttempts(errors?.cause?.data?.remaining_verification_attempts);
            }
            setIsErrorModalOpen(true);
            return;
          }

          if (errors.message.toUpperCase() === "OTP EXPIRED") {
            setIsOtpExpired(true);
            setOtpAttempts(null);
            return;
          }

          if (errors.message === "OTP verification attempt limit exceeded, SMS channel(s) have been blocked") {
            setIsMaxAttemptsReached(true);
            setIsErrorModalOpen(true);
          }

          console.log(errors.message, "handle this error here");
        }

        console.log(errors, "handle this error");
        return;
      }

      if (data) {
        if (data.response.message) {
          if (data.response.message.toUpperCase() === "OTP VERIFIED") {
            await sendOrders({ cartItems, clientInfo, totalCost });

            // successfull order & verification
            await firePlaceOrderEvent(
              clientInfo.mobile_number,
              clientInfo.store_name,
              clientInfo.full_name,
              clientInfo.complete_address
            );

            navigate(`/${distributor}/order-status`);
          } else {
            console.log("handle error here");
          }
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const pinInputHandler = (val) => {
    const pin = pinRef.current;
    const currentIndex = pin.currentIndex; // current index of the input
    const currentInputElement = pin.elements[currentIndex]; // current input element based on the current index
    const inputLength = pin.elements.length;
    setAutoSelect(!autoSelect);
    if (val === "erase") {
      const updatedIndex = currentIndex === 0 ? 0 : currentIndex - 1; // get the updated index to be used for removing the value of the input element
      const previousInputElement = pin.elements[updatedIndex]; // get the previous input element
      previousInputElement.state.value = ""; // erase the value of the input element
      setOtpVal((prev) => prev.substring(0, prev.length - 1)); // update the otp value
      pin.currentIndex = updatedIndex; // updating the current index of the ref
      return;
    }
    if (currentIndex === inputLength) return; // should not be able to input if the input is the last input and has value
    currentInputElement.state.value = val; // saving the value on the input
    setOtpVal((prev) => prev + val); // update the otp value
    // currentInputElement.state.showSecret = true; // saving the value on the input
    pin.currentIndex += 1; // updating the current index of the ref
  };

  useEffect(() => {
    if (!clientInfo.mobile_number) return;

    const getOtp = async () => {
      const { errors } = await generateOTP({
        variables: {
          mobile_number: clientInfo.mobile_number,
          get_standard: false,
          request_type: ENVIRONMENT === "DEV" ? "SUKICLUB" : "SARIPAY",
          delivery_channel: "sms",
        },
      });

      if (errors) {
        if (errors.message) {
          if (errors.message === "Your mobile number is currently blacklisted. Please contact Customer Support") {
            setIsErrorModalOpen(true);
            setIsMaxAttemptsReached(true);
          }
        }
      }
    };

    getOtp();
  }, [clientInfo, generateOTP]);

  useEffect(() => {
    fireViewScreenEvent(CURRENT_SCREEN_NAME.menu_verify_otp);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Stack sx={{ minHeight: "100vh", minWidth: "100vw" }} spacing={2}>
      <ModalBox modal={isErrorModalOpen}>
        <Box sx={{ display: "flex", flexDirection: "column", textAlign: "center", gap: 2.5 }} px={1} py={2.5}>
          <Box>
            <ErrorIcon size={53} />
          </Box>
          <Box sx={{ fontSize: "17px", fontWeight: 700, letterSpacing: "0.75" }}>
            {isMaxAttemptsReached ? "Max attempts for OTP reached" : "Incorrect OTP"}
          </Box>
          <Box sx={{ fontSize: "15px", fontWeight: 400, letterSpacing: "0.75" }}>
            {isMaxAttemptsReached
              ? "Maghintay ng 4 hours bago subukan ulit mag-order."
              : "Ilagay ang OTP na pinadala sa iyong mobile number."}
          </Box>

          {!isMaxAttemptsReached && (
            <Box sx={{ fontSize: "15px", fontWeight: 400, letterSpacing: "0.75" }}>
              {otpAttempts === 1 ? `${otpAttempts} attempt` : `${otpAttempts} attempts`} left.
            </Box>
          )}

          <ThemedButton
            variant="contained"
            size="small"
            onClick={() => {
              if (isMaxAttemptsReached) {
                clearData();
                navigate(`/${distributor}/products`);
              }
              setIsErrorModalOpen(false);
              clearPin();
            }}
          >
            {isMaxAttemptsReached ? "Try again later" : "Try again"}
          </ThemedButton>
        </Box>
      </ModalBox>
      <Header backAction={() => navigate(`/${distributor}/confirm-order`)} />
      <Stack px={2.25} spacing={0.25}>
        <Item className="tx700 tx125 ls100">Enter OTP</Item>
        <Item className="ls25 lh150" sx={{ fontSize: "15px" }}>
          Nagpadala kami ng One-Time Password (OTP) sa {mobileNumber} via <b>SMS</b>. Mag-eexpire ito makalipas ang 5
          minuto.
        </Item>
      </Stack>

      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: 1.5 }}>
        <PinInput
          length={6}
          ref={pinRef}
          initialValue=""
          //   secret
          //   secretDelay={100}
          onChange={onChangePinHandler}
          type="numeric"
          inputMode="number"
          autoSelect={autoSelect}
          regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
          autoFocus
        />
        {otpAttempts && otpAttempts <= 2 && (
          <Box sx={{ fontSize: "13px", fontWeight: 400, letterSpacing: "0.25px", color: "#E81C3A" }}>
            {otpAttempts === 1 ? `${otpAttempts} attempt` : `${otpAttempts} attempts`} left
          </Box>
        )}
        {isOtpExpired && (
          <Box sx={{ fontSize: "13px", fontWeight: 400, letterSpacing: "0.25px", color: "#E81C3A" }}>
            OTP Expired, please try again
          </Box>
        )}
      </Box>

      <NumPad onClickButton={pinInputHandler} />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          paddingTop: 1,
        }}
      >
        <Item sx={{ color: "#6E7191" }}>Walang natanggap na OTP?</Item>
        <Item sx={{ background: "transparent" }}>
          <OtpTimer
            seconds={59}
            minutes={ENVIRONMENT === "DEV" ? 0 : 4}
            text="Resend in"
            ButtonText="Resend"
            background="transparent"
            buttonColor="#008577"
            textColor="#A0A1AD"
            resend={() => {
              generateOTP({
                variables: {
                  mobile_number: clientInfo.mobile_number,
                  get_standard: false,
                  request_type: ENVIRONMENT === "DEV" ? "SUKICLUB" : "SARIPAY",
                  delivery_channel: "sms",
                },
              });
            }}
          />
        </Item>
      </Box>

      <Grid container sx={{ height: 80 }} />
      <Stack spacing={2} sx={{ left: 0, bottom: 18, height: 72.5, position: "fixed", width: "100%" }}>
        <Item>
          <Divider />
        </Item>
        <Item sx={{ px: 2 }}>
          <ThemedButton
            fullWidth
            variant="contained"
            sx={{ fontWeight: 700 }}
            onClick={onVerifyUser}
            disabled={!(otpVal.length === 6)}
          >
            <span style={{ fontWeight: 700 }}>Verify</span>
          </ThemedButton>
        </Item>
      </Stack>
    </Stack>
  );
};

export default VerifyUserPage;
